    const chargeRoutes = [
    {
        path: "/charge",
        name: "charges",
        component: () => import("@/views/charge/Charges.vue")
    },
    {
        path: "/charge/:id?",
        name: "charge",
        component: () => import("@/views/charge/Charge"),
        props: route => {
            const id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                return 0;
            }
            return {id};
        }
    },
    // {
    //     path: "/charge/:id/:scheduleID",
    //     name: "chargeSchedule",
    //     component: () => import("@/views/charge/ChargeSchedule"),
    //     props: route => {
    //         let id = Number.parseInt(route.params.id, 10);
    //         if (Number.isNaN(id)) {
    //             id = 0;
    //         }
    //
    //         let scheduleID = Number.parseInt(route.params.scheduleID, 10);
    //         if (Number.isNaN(scheduleID)) {
    //             scheduleID = 0;
    //         }
    //         return {id: id, scheduleID: scheduleID};
    //     }
    //
    // }
]
export default chargeRoutes